import { cn } from '@/lib/cn';
import { useMemo } from 'react';

export interface BlurMaskOverlayProps {
  clearUntilPx: number;
  fadePx: number;
  className?: string;
}

export const BlurMaskOverlay = ({ clearUntilPx, fadePx, className }: BlurMaskOverlayProps) => {
  const mask = useMemo(
    () =>
      `linear-gradient(to bottom, transparent 0px, transparent ${clearUntilPx}px, black ${
        clearUntilPx + fadePx
      }px)`,
    [clearUntilPx, fadePx]
  );

  return (
    <div
      className={cn(
        'absolute inset-0 z-20 bg-gradient-to-b from-transparent to-surface-container backdrop-blur-[5px]',
        className
      )}
      style={{
        maskImage: mask,
        WebkitMaskImage: mask,
      }}
      aria-hidden="true"
    />
  );
};
